interface IntercomCommandSignature {
	showNewMessage: (prepopulateMessage?: string) => void
	trackEvent: (tag?: string, metadata?: Record<string, unknown>) => void
	update: (data?: Record<string, unknown>) => void
}

type IntercomCommand = keyof IntercomCommandSignature

// https://developers.intercom.com/installing-intercom/docs/intercom-javascript
type IntercomStatic = <Command extends IntercomCommand>(
	command: Command,
	...params: Parameters<IntercomCommandSignature[Command]>
) => ReturnType<IntercomCommandSignature[Command]>

declare global {
	interface Window {
		Intercom: IntercomStatic
	}
}

export const showNewMessage = (message?: string) => {
	// Pass lokalise_user_id and active_team_id as custom attributes when starting a conversation
	if (window.intercomSettings?.lokalise_user_id || window.intercomSettings?.active_team_id) {
		const updateData: Record<string, string> = {}
		if (window.intercomSettings.lokalise_user_id) {
			updateData.lokalise_user_id = window.intercomSettings.lokalise_user_id
		}
		if (window.intercomSettings.active_team_id) {
			updateData.active_team_id = window.intercomSettings.active_team_id
		}
		if (window.intercomSettings.active_team_plan_name) {
			updateData.active_team_plan_name = window.intercomSettings.active_team_plan_name
		}
		if (window.intercomSettings.active_team_pricing_version) {
			updateData.active_team_pricing_version = window.intercomSettings.active_team_pricing_version
		}
		if (window.intercomSettings.active_team_role) {
			updateData.active_team_role = window.intercomSettings.active_team_role
		}
		window.Intercom?.('update', updateData)
	}
	window.Intercom?.('showNewMessage', message)
}
export const trackEvent = (eventName: string, metadata?: Record<string, unknown>) =>
	window.Intercom?.('trackEvent', eventName, metadata)

export default {
	showNewMessage,
	trackEvent,
}
